// extracted by mini-css-extract-plugin
export default {"divchatbot":"chatbot_divchatbot__JsaUY","inputchatbot":"chatbot_inputchatbot__Zn6Qg","submitchatbot":"chatbot_submitchatbot__0VMQV"};